<script>
import {httpAction, postAction} from "../../../utils/api/manages";

export default {
  name: "manufacturers",
  props: {
    productCategoryId: String,
    type: String,
  },
  data() {
    return {
      // 厂商列表
      manufacturers: [],
      activeName: null,
      sortList: [
        {field: 'totalScore', name: '分数', type: 'order', active: false},
        {field: 'commentNumber', name: '评论数', type: 'order', active: false},
        {field: 'hitNum', name: '浏览数', type: 'order', active: false},
        {field: 'careNum', name: '收藏数', type: 'order', active: false},
      ],
      sortActive: null,
      search: {
        orderField: null, // 排序字段
        orderType: null, // 排序类型
        filterName: null // 搜索内容
      }
    }
  },
  created() {
    this.getManufacturers()
    this.activeName = null
  },
  watch: {
    productCategoryId(val) {
      this.getManufacturers()
      this.activeName = null
    }
  },
  methods: {
    // 获取厂商列表
    getManufacturers() {
      if (!this.productCategoryId) return
      const categoryType = this.type === '1' ? 0 : 1
      // postAction(`/product/tag/getAll/${this.productCategoryId}/${categoryType}`).then(res => {
      //   this.manufacturers = res.data.at(0)?.tags
      // })
      httpAction({
        url:`/product/tag/getAll/${this.productCategoryId}/${categoryType}`,
        method: 'post',
        noToken: true,
      }).then(res => {
        this.manufacturers = res.data.at(0)?.tags
      })
    },
    itemClick(item) {
      if (!item) {
        this.activeName = null
        this.search.filterName = null
      } else {
        this.activeName = item.tagName
        this.search.filterName = item.tagName
      }
      this.$emit('search', this.search)
    },
    sortChange(item) {
      if (item.field === this.sortActive) {
        let type = item.type === 'order' ? 'desc' : 'order'
        this.$set(item, 'type', type)
      } else {
        this.$set(item, 'type', 'desc')
      }
      this.sortActive = item.field
      this.sortList.forEach(item => {
        if (item.field !== this.sortActive) {
          this.$set(item, 'type', 'order')
        }
      })
      this.search.orderField = this.sortActive
      this.search.orderType = item.type
      this.$emit('search', this.search)
    },
    reset() {
      this.activeName = null;
      this.search = {
        orderField: null, // 排序字段
        orderType: null, // 排序类型
        filterName: null // 搜索内容
      }
      this.sortActive = null
      this.sortList.forEach(item => {
        this.$set(item, 'type', 'order')
      })
    }
  }
}
</script>

<template>
  <div class="manufacturers">
    <div class="makers">
      <div class="title">厂商：</div>
      <div class="list">
        <div class="options" @click="itemClick()" :class="activeName===null?'active':null">全部</div>
        <div class="options"
             v-for="(item,index) in manufacturers"
             :key="index" @click="itemClick(item)"
             :class="activeName===item.tagName?'active':null"
        >
          {{ item.tagName }}
        </div>
      </div>
    </div>
    <div class="dottedLine"></div>
    <div class="sort">
      <div class="title">排序：</div>
      <div class="list">
        <div class="options"
             v-for="(item,index) in sortList"
             @click="sortChange(item)"
             :class="sortActive === item.field ? 'active' : null"
        >
          <el-divider direction="vertical" style="margin: 0 5px" v-if="index"></el-divider>
          <div class="name">{{ item.name }}</div>
          <span :class="item.type==='order'?'el-icon-top':'el-icon-bottom'"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.manufacturers {
  padding: 20px;
  background-color: #fff;
  margin: 20px 0;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .dottedLine {
    border-bottom: 1px dashed #ebebeb;

    padding: 4px 0;
    margin-bottom: 8px;
  }

  .title {
    color: #232f3e;
    font-weight: 600;
    padding: 5px 0;
  }

  .makers {
    display: flex;
    flex-shrink: 0;
    gap: 10px;

    .list {
      flex: 1;
      display: flex;
      gap: 10px;
      align-items: center;
      flex-wrap: wrap;
      flex-shrink: 0;

      .options {
        padding: 5px 14px;
        color: #666;
        //line-height: 30px;
        cursor: pointer;
        border-radius: 30px;

        &:hover {
          background-color: #f5f5f5;
          color: var(--swiper-theme-color);
        }

        &.active {
          background-color: var(--swiper-theme-color);
          color: #fff;
        }
      }
    }
  }

  .sort {
    display: flex;
    flex-shrink: 0;
    gap: 10px;

    .list {
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      flex-shrink: 0;

      .options {
        user-select: none;
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
          color: var(--swiper-theme-color);
        }

        &.active {
          color: var(--swiper-theme-color);
        }
      }
    }
  }
}

</style>